import { httpRequest, endpoint } from "@cirrus/core/http"

export const getReviewCandidates = async (reviewSessionId) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/delivering/review-sessions/${reviewSessionId}/info`),
  )
